import React from "react";
import { Navigate } from "react-router-dom";

function Protected({ children }) {
  const loginCheck = String(localStorage.getItem("logged_in"));
  return loginCheck == "true" ? children : <Navigate to="/" replace />;
}

export default Protected;
